import { Injectable } from '@angular/core';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { of } from 'rxjs';

import { timeout, catchError } from "rxjs/operators";
import { environment } from 'src/environments/environment';
import { creditDefaultConsumer, creditDefaultCommercial } from './dto/contribution.dto';

@Injectable({
  providedIn: 'root'
})
export class ContributionService {

  constructor(
    private http: HttpClient,
    private localStorageService: LocalStorageService,
  ) { }

  generateSessionContribution() {
    const url = this.localStorageService.configInit['F_INIT_TOKEN_CONTRIBUTION_URL'];
    const username = this.localStorageService.configInit['F_INIT_TOKEN_CONTRIBUTION_USERNAME'];
    const psw = this.localStorageService.configInit['F_INIT_TOKEN_CONTRIBUTION_PASS'];

    const basicAuth = btoa(`${username}:${psw}`);

    const scope = this.localStorageService.configInit['F_CONTRIBUTION_SCOPE'];

    const body = new HttpParams()
      .set('grant_type', 'client_credentials')
      .set('scope', scope);

    const headers = new HttpHeaders({
      'Authorization': `Basic ${basicAuth}`,
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post(url, body.toString(), { headers });
  }

  generateBodyContribution(contributionData: any, supplierId: string, contributionName: string, periodo, geo: string, profile: any) {
    contributionData = profile === "CONSUMER" ?
      creditDefaultConsumer(contributionData)
      : creditDefaultCommercial(contributionData);
    return {
      userId: this.localStorageService.configInit['F_CONTRIBUTION_USER'],
      supplierId,
      contributionData,
      contributionName,
      periodo,
      delimitador: "\t",
      geo
    };
  }

  getContributionName(suplieId: string, idContribution: string, eventTrackingId?: string) {
    // ?eventTrackingId=9527
    const baseURL = this.localStorageService.configInit['F_CONTRIBUTION_URL'];
    const url = `${baseURL}/find_detail/one_per_one/${suplieId}?idContribution=${idContribution}`;
    return this.http.get(url)
  }

  generateContribution(token: string, body) {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    })
    const baseURL = this.localStorageService.configInit['F_CONTRIBUTION_URL'];
    const url = `${baseURL}/contrib-gen-service/contribution`;
    return this.http.post(url, body, { headers })
  }

  getContribution(suplieId: string, idContribution: string, eventTrackingId?: string) {
    // ?eventTrackingId=9527
    const baseURL = this.localStorageService.configInit['F_CONTRIBUTION_URL'];
    const url = `${baseURL}/find_detail/one_per_one/${suplieId}?idContribution=${idContribution}`;
    return this.http.get(url).pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)), catchError(err => of({ error: true, err, payload: { error: [] } })));
  }

  getPersistenceContributionId(suplieId: string) {
    let urlBaseApi: string = this.localStorageService.configInit["F_VIP_URL_BASE_API"];
    let apiVip: string = 'vip/gcp-service';
    const url = `${urlBaseApi}/${apiVip}/v1/contributions/data/${suplieId}`;

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    return this.http.get(url, { headers })
  }

  postPersistenceContribution(body: any) {
    const { supplierId } = body;
    let urlBaseApi: string = this.localStorageService.configInit["F_VIP_URL_BASE_API"];
    let apiVip: string = 'vip/gcp-service';
    const url = `${urlBaseApi}/${apiVip}/v1/contributions/data/charge/${supplierId}`;

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    return this.http.post(url, body, { headers })
  }

  getSuplierInformation(universalSupplier: string, geo: string) {
    const baseURL = this.localStorageService.configInit['F_CONTRIBUTION_URL'];
    const url = `${baseURL}/contrib-gen-service/portal/contribution/find/supplier-information`;
    const tokenApigee = localStorage.getItem('tokenAPIGEE') || '';
    const params = new HttpParams()
      .set('universalSupplier', universalSupplier)
      .set('geo', (geo || '').toUpperCase());

    const headers = new HttpHeaders({
      'Accept': 'application/json',
      ...(tokenApigee ? { 'Authorization': `Bearer ${tokenApigee}` } : {})
    });

    // DEBUG: Log exact request details for backend investigation
    console.log('[getSuplierInformation] URL completa:', url);
    console.log('[getSuplierInformation] Token (primeros 20 chars):', tokenApigee ? tokenApigee.substring(0, 20) + '...' : 'VACÍO');
    console.log('[getSuplierInformation] Query Params:', { universalSupplier, geo: (geo || '').toUpperCase() });
    console.log('[getSuplierInformation] Headers enviados:', headers.keys().map(key => `${key}: ${headers.get(key)}`));

    return this.http.get(url, { headers, params });
  }

}
